// The browser tab's title for each page in the app shell, so tabs, history
// and screen readers say where you are. The names match the nav
// (navigation/navConfig). Pages outside the shell (sign-in, reset password,
// sign-up) set their own.

const TITLES: Record<string, string> = {
  '/': 'Today',
  '/plan': 'Plan',
  '/close-day': 'Close the day',
  '/focus': 'Focus',
  '/focus/capacity': 'Capacity',
  '/calendar': 'Calendar',
  '/review': 'Review',
  '/review/ideas': 'Ideas',
  '/review/captured': 'Captured',
  '/work': 'Work',
  '/projects': 'Projects',
  '/drivers': 'Drivers',
  '/drivers/horizon': 'Horizon',
  '/decisions': 'Decisions',
  '/insights': 'Insights',
  '/insights/time': 'Time',
  '/insights/drivers': 'Drivers & projects',
  '/insights/activity': 'Activity',
  '/insights/reflections': 'Reflections',
  '/assistant': 'Executives',
  '/assistant/workspace': 'Workspace',
  '/assistant/profiles': 'Executive profiles',
  '/feature-requests': 'Feature Requests',
  '/settings': 'Settings',
  '/settings/overview': 'Settings',
  '/settings/your-day': 'Your day',
  '/settings/about-you': 'About you',
  '/settings/calendar': 'Calendar settings',
  '/settings/notifications': 'Notifications',
  '/settings/assistants': 'Assistants & agents',
  '/settings/connected-apps': 'Connected apps',
  '/settings/profile': 'Profile',
  '/settings/security': 'Security',
  '/settings/appearance': 'Appearance',
  '/settings/apps': 'Apps & devices',
  '/settings/plan': 'Your plan',
  '/organisation': 'Organisation',
  '/organisation/overview': 'Organisation',
  '/organisation/people': 'People',
  '/organisation/teams': 'Teams',
  '/organisation/billing': 'Plan & billing',
  '/organisation/security': 'Organisation security',
  '/organisation/ai-integrations': 'AI & integrations',
  '/organisation/audit-log': 'Audit log',
  '/mfa-setup': 'Two-step sign-in',
  '/getting-started': 'Getting started',
  '/platform': 'Platform',
  '/platform/tenants': 'Tenants',
  '/platform/products': 'Products & Pricing',
  '/platform/email': 'Email Settings',
  '/platform/security': 'Security & Diagnostics',
  '/platform/bug-reports': 'Bug Reports',
  '/platform/billing': 'Billing Centre',
  '/platform/releases': 'Client Releases',
};

/**
 * The page's name as the nav gives it, for /work and for a page under one
 * (/projects/42 → Projects); null for an address with no name of its own.
 */
export function pageNameFor(pathname: string): string | null {
  const trimmed = pathname.toLowerCase().replace(/\/+$/, '');
  let path = trimmed || '/';
  while (path !== '/' && !(path in TITLES)) {
    path = path.slice(0, path.lastIndexOf('/')) || '/';
  }
  // Walked all the way back without a match: a page with no name of its own.
  if (path === '/' && trimmed !== '') return null;
  return TITLES[path];
}

/**
 * "Work · Cadence" for /work, and for a page under one (/projects/42 → Projects).
 * A platform admin's "/" is their console, not Today.
 */
export function pageTitleFor(pathname: string, o: { platformAdmin?: boolean } = {}): string {
  const trimmed = pathname.toLowerCase().replace(/\/+$/, '');
  if (o.platformAdmin && trimmed === '') return `${TITLES['/platform']} · Cadence`;
  const name = pageNameFor(pathname);
  return name ? `${name} · Cadence` : 'Cadence';
}
